import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=381f5b32&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f5b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381f5b32')) {
      api.createRecord('381f5b32', component.options)
    } else {
      api.reload('381f5b32', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=381f5b32&scoped=true&", function () {
      api.rerender('381f5b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xTK9ImJYlbc/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports